import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const deleteCurrencyFunc = createAsyncThunk("currency/delete", async (id) => {
  const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
  const request = await fetch(
    `${process.env.REACT_APP_VERSEL_API}/api/user/currencies/${id}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${tokenData}`,
      },
    }
  )
    .then((respons) => respons.json())
    .then((resulet) => {
      return resulet;
    })
    .catch((e) => {
      return e;
    });

  return request;
});


const deleteCurrencySlicer = createSlice({
  name: "currency/delete",
  initialState: {
    responst: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(deleteCurrencyFunc.fulfilled, (state, action) => {
      if (action.payload.message === "deleted successfully") {
        state.responst = action.payload.message;
      } else {
        state.error = action.payload.message;
      }
    });
    builder.addCase(deleteCurrencyFunc.rejected, (state, action) => {
      state.error = action.payload.message;
    });
  },
});

export default deleteCurrencySlicer.reducer;
